import React from 'react';
import styles from './AboutMe.css';
import author from '../../../assets/maciek1.jpg';
import spacer from '../../../assets/spacer.png';

const oneliners = {    
    1: "Urodzony w roku, w którym świat usłyszał o Terminatorze.",
    2: "Zaborczo zafascynowany prozą H.P. Lovecrafta. Absolutny i bezrefleksyjny fanboy Kinga i Gaimana.",
    3: "Warhammer for life!",
    4: 'PREMIERA NOWEJ KSIĄŻKI:',
    5: '27 luty 2019'
};

const AboutMe = (props) => (
    <div className={styles.mainDiv}>
        <img src={author} className={styles.mainImg} alt="Maciek Lewandowski"/>
        <h1 className={styles.title}>O SOBIE SŁÓW KILKA</h1>
        <p className={styles.subtitle} onClick={props.clicked}>{oneliners[4]}</p>
        <p className={styles.subtitle} onClick={props.clicked}>{oneliners[5]}</p>
        <img src={spacer} className={styles.spacer} alt="spacer"/>
        <p className={styles.text}>{oneliners[1]}</p>
        <img src={spacer} className={styles.spacer} alt="spacer"/>
        <p className={styles.text}>{oneliners[2]}</p>
        <img src={spacer} className={styles.spacer} alt="spacer"/>
        <p className={styles.text}>{oneliners[3]}</p>
    </div>
);

export default AboutMe;


// WEBPACK FOOTER //
// ./src/components/Mobile/AboutMe/AboutMe.js